import { createSlice, createAsyncThunk } from "@reduxjs/toolkit";
import { api} from "../ui/api";

export const getSeminar = createAsyncThunk("seminar/fetchSeminars", async (_, { rejectWithValue }) => {
    try {
        const response = await api.get("/courses/seminars/");
        return response.data;
    } catch (error) {
        return rejectWithValue(error.response?.data?.detail || error.message);
    }
});
export const getSeminarById = createAsyncThunk(
    "seminar/fetchSeminarById",
    async (id, { rejectWithValue }) => {
        try {
            const response = await api.get(`/courses/seminars/${id}/`);
            return response.data;
        } catch (error) {
            return rejectWithValue(error.message);
        }
    }
);

const seminarSlice = createSlice({
    name: "seminar",
    initialState: {
        seminar: [],
    },
    extraReducers: (builder) => {
        builder
            .addCase(getSeminar.pending, (state) => {
                state.loading = true;
                state.error = null;
            })
            .addCase(getSeminar.fulfilled, (state, action) => {
                state.loading = false;
                state.seminar = action.payload;
            })
            .addCase(getSeminar.rejected, (state, action) => {
                state.loading = false;
                state.error = action.payload;
            })
            .addCase(getSeminarById.pending, (state) => {
                state.loading = true;
                state.error = null;
            })
            .addCase(getSeminarById.fulfilled, (state, action) => {
                state.loading = false;
                state.seminar = action.payload;
            })
            .addCase(getSeminarById.rejected, (state, action) => {
                state.loading = false;
                state.error = action.payload;
            })
    },
});

export default seminarSlice.reducer;
